import { produce } from 'immer';
import { CreateEditCartUi } from './CreateEditUiModel';

export function validateInputs(
  input: CreateEditCartUi,
  isDraft: boolean
): true | CreateEditCartUi {
  let errorsFound = false;
  const validatedModel = produce(input, (draft) => {
    if (!draft.buyer) {
      draft.buyerError = 'Campo requerido';
      errorsFound = true;
    }
    draft.products.forEach((product) => {
      if (!product.quantity) {
        product.quantityError = 'Cantidad no válida';
        errorsFound = true;
      }
      if (!product.customPricing.trim()) {
        product.customPricingError = 'Precio no válido';
        errorsFound = true;
      }
    });
    if (!isDraft) {
      draft.sellers.forEach((seller) => {
        if (!seller.deliveryDate?.isValid()) {
          seller.deliveryDateError = 'Fecha no válida';
          errorsFound = true;
        }
        if (
          !seller.deliveryStartTime?.isValid() ||
          !seller.deliveryEndTime?.isValid() ||
          !seller.deliveryEndTime.isAfter(seller.deliveryStartTime)
        ) {
          seller.deliveryTimeError =
            'La hora final debe ser mayor a la hora de inicio.';
          errorsFound = true;
        }
      });
    }
  });
  return errorsFound ? validatedModel : true;
}
